import React, { useState } from "react";
import { httpsCallable } from "firebase/functions";
import { functions } from "../firebase";
import { useTheme } from "../contexts/ThemeContext";
import { Database, Download, CheckCircle, AlertCircle } from "lucide-react";

const AdminClinicSeeder = () => {
  const { themeClasses } = useTheme();
  const [loading, setLoading] = useState(false);
  const [result, setResult] = useState(null);
  const [error, setError] = useState(null);

  const seedClinics = async () => {
    setLoading(true);
    setError(null);
    setResult(null);

    try {
      const seedNorwegianClinics = httpsCallable(
        functions,
        "seedNorwegianClinics"
      );
      const response = await seedNorwegianClinics();

      if (response.data.success) {
        setResult(response.data);
      }
    } catch (error) {
      console.error("Error seeding clinics:", error);
      setError(error.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div
      className={`${themeClasses.bg.card} rounded-lg border ${themeClasses.border.primary} p-6`}
    >
      <div className="flex items-center space-x-3 mb-4">
        <Database className={`w-6 h-6 ${themeClasses.text.accent}`} />
        <h3 className={`text-xl font-semibold ${themeClasses.text.primary}`}>
          Seed Norwegian Veterinary Clinics
        </h3>
      </div>

      <p className={`${themeClasses.text.secondary} mb-6`}>
        This will fetch Norwegian veterinary clinics from official sources and
        populate your database.
        <br />
        <strong>Sources:</strong> Brønnøysundregistrene (Norwegian Business
        Registry) + Manual entries
      </p>

      <button
        onClick={seedClinics}
        disabled={loading}
        className={`${themeClasses.bg.button} text-white px-6 py-3 rounded-lg disabled:opacity-50 transition-all duration-200 flex items-center space-x-2`}
      >
        {loading ? (
          <>
            <div className="animate-spin rounded-full h-5 w-5 border-b-2 border-white"></div>
            <span>Fetching clinics...</span>
          </>
        ) : (
          <>
            <Download className="w-5 h-5" />
            <span>Seed Norwegian Clinics</span>
          </>
        )}
      </button>

      {/* Success Result */}
      {result && (
        <div className="mt-6 p-4 bg-green-50 border border-green-200 rounded-lg">
          <div className="flex items-center space-x-2 mb-2">
            <CheckCircle className="w-5 h-5 text-green-600" />
            <span className="font-semibold text-green-800">Success!</span>
          </div>
          <div className="text-sm text-green-700">
            <p>
              <strong>Message:</strong> {result.message}
            </p>
            <p>
              <strong>Total Fetched:</strong> {result.totalFetched} clinics
            </p>
            <p>
              <strong>Total Inserted:</strong> {result.totalInserted} clinics
            </p>
            <p>
              <strong>Sources:</strong> {result.sources.join(", ")}
            </p>
          </div>
        </div>
      )}

      {/* Error */}
      {error && (
        <div className="mt-6 p-4 bg-red-50 border border-red-200 rounded-lg">
          <div className="flex items-center space-x-2 mb-2">
            <AlertCircle className="w-5 h-5 text-red-600" />
            <span className="font-semibold text-red-800">Error</span>
          </div>
          <p className="text-sm text-red-700">{error}</p>
        </div>
      )}
    </div>
  );
};

export default AdminClinicSeeder;
